import { TabNavigation } from 'features/incidents/components/enums'
import { AdminRoles, ClaimStatus, ServicesAssessmentsEnum, ServicesEnum } from 'utils/enum'

export const NODE_ENV = process.env.REACT_APP_NODE_ENV
export const API_URL = process.env.REACT_APP_API_URL
export const POLY_EXPLORER_URL = process.env.REACT_APP_EXPLORER_URL
export const PLOYGON_AMOY_RPC_URL = process.env.REACT_APP_PLOYGON_AMOY_RPC_URL
export const Contract_Address = process.env.REACT_APP_CONTRACT_ADDRESS
export const Chain_Id = Number(process.env.REACT_APP_CHAIN_ID)
export const USER_AFFILIATELINK = process.env.REACT_APP_AFFILIATE_LINK

export const routes = {
  // general
  home: '/',
  about: '/about',
  security: '/security',
  // auth
  login: '/login',
  register: '/register',
  reset: '/reset-password',
  forgot: '/forgot-password',
  // dashboard
  secureScore: '/app/secure-score-summary',
  dashboard: '/app',
  incidents: '/app/incidents',
  users: '/app/users',
  insurancePlans: '/app/insurance-plans',
  addInsurancePlan: '/app/insurance-plans/add-plan',
  addInsurancePolicy: '/app/insurance-plans/add-policy',
  updateInsurancePolicy: '/app/insurance-plans/update-policy',
  addUser: '/app/users/add-user',
  cyraAI: '/app/cyra-ai',

  editProfile: '/app/profile/edit',
  changePass: '/app/profile/change',
  // setting
  profile: '/app/setting/profile',
  admins: '/app/setting/admins',
  addAdmin: '/app/setting/add-admin',
  companyDetails: '/app/setting/company-details',
  resendVerificationLink: '/auth/resend-verification-link',
  companyServices: '/app/setting/company-services',
  twoFactorAuthentication: '/app/setting/two-factor-authentication',
}

export const steps = ['Incident Detected', 'Verifiying Incident', 'Initiate Claim', 'Benefits Confirmation', 'User Confirmation ', 'Block Creation', ' Resolved']
export const textArray = ['EDR', 'Cove Data Backup', 'N-Sight Patch', 'Window Defender', 'Microsoft Secure Score']
export const ClaimStatusList = [
  {
    label: ClaimStatus.ALL,
    value: '',
  },
  {
    label: ClaimStatus.APPLICABLE,
    value: ClaimStatus.APPLICABLE,
  },
  {
    label: ClaimStatus.NOT_APPLICABLE,
    value: ClaimStatus.NOT_APPLICABLE,
  },
  {
    label: ClaimStatus.CLAIM_RAISED,
    value: ClaimStatus.CLAIM_RAISED,
  },
  {
    label: ClaimStatus.APPROVED,
    value: ClaimStatus.APPROVED,
  },
  {
    label: ClaimStatus.DISAPPROVED,
    value: ClaimStatus.DISAPPROVED,
  },
  {
    label: ClaimStatus.ACCEPTED,
    value: ClaimStatus.ACCEPTED,
  },
  {
    label: ClaimStatus.REJECTED,
    value: ClaimStatus.REJECTED,
  },
  {
    label: ClaimStatus.RE_EVALUATE,
    value: ClaimStatus.RE_EVALUATE,
  },
]
// BreachRx CIRM runs on the Microsoft Secure Score integration, but is presented
// under its own name. Mirrors the same constants in the user portal. Keyed on the
// carrier, so every warranty BreachRx writes is covered, not just the first one.
// Overridable per environment because the company id differs between databases.
export const BREACHRX_CIRM_COMPANY_ID = Number(process.env.REACT_APP_BREACHRX_COMPANY_ID) || 32
export const BREACHRX_CIRM_SERVICE_NAME = 'BreachRx API Connectivity'
export const BREACHRX_CIRM_BUTTON_LABEL = 'Direct BreachRx API coming soon'
// Shown on the warranty itself, where there is no per-holder connection to report
export const BREACHRX_CIRM_STATUS_LABEL = 'Coming Soon'

export const serviceArray = [
  ServicesEnum.EDR,
  ServicesEnum.COVE_DATA,
  ServicesEnum.N_SIGHT_AV,
  ServicesEnum.N_SIGHT_PATCH,
  ServicesEnum.N_CENTERAL,
  ServicesEnum.Microsoft_Secure_Score,
  ServicesEnum.Windows_Defender,
]
//for Company Services tab
export const ServicesAssessments = {
  'Backup': [ServicesAssessmentsEnum.COVE_DATA],
  'Anti-Virus or EDR': [ServicesAssessmentsEnum.EDR, ServicesAssessmentsEnum.Crowd_Strike, ServicesAssessmentsEnum.Malware_Bytes],
  'Patch Management': [ServicesAssessmentsEnum.N_SIGHT_PATCH, ServicesAssessmentsEnum.Bitdefender_Gravity, ServicesAssessmentsEnum.Windows_Defender],
  'Microsoft Graph': [ServicesAssessmentsEnum.Microsoft_Secure_Score],
}

export const AdminRoleList = [
  {
    label: AdminRoles.SUB,
    value: AdminRoles.SUB,
    key: 1,
  },
  {
    label: AdminRoles.SUPER,
    value: AdminRoles.SUPER,
    key: 2,
  },
]

export const TAB_CONFIG = [
  {
    label: 'Sentinel One',
    tabNumber: TabNavigation.Tab0,
  },
  {
    label: 'Cove Data Backup',
    tabNumber: TabNavigation.Tab1,
  },
  {
    label: 'N-sight Patch',
    tabNumber: TabNavigation.Tab2,
  },
  {
    label: 'Window Defender',
    tabNumber: TabNavigation.Tab3,
  },
  {
    label: 'Microsoft Office 365',
    tabNumber: TabNavigation.Tab4,
  },
]
export const SectorList = [
  { label: 'Accounting', value: 'accounting' },
  { label: 'Aerospace/Defense', value: 'aerospace-defense' },
  { label: 'Airlines/Aviation', value: 'airlines-aviation' },
  { label: 'Alternative Dispute Resolution', value: 'alternative-dispute-resolution' },
  { label: 'Alternative Medicine', value: 'alternative-medicine' },
  { label: 'Animation', value: 'animation' },
  { label: 'Apparel & Fashion', value: 'apparel-fashion' },
  { label: 'Architecture & Planning', value: 'architecture-planning' },
  { label: 'Arts and Crafts', value: 'arts-and-crafts' },
  { label: 'Automotive', value: 'automotive' },
  { label: 'Aviation & Aerospace', value: 'aviation-aerospace' },
  { label: 'Banking', value: 'banking' },
  { label: 'Biotechnology', value: 'biotechnology' },
  { label: 'Broadcast Media', value: 'broadcast-media' },
  { label: 'Building Materials', value: 'building-materials' },
  { label: 'Business Services', value: 'business-services' },
  { label: 'Business Supplies and Equipment', value: 'business-supplies-equipment' },
  { label: 'Capital Markets', value: 'capital-markets' },
  { label: 'Chemicals', value: 'chemicals' },
  { label: 'Civic & Social Organization', value: 'civic-social-organization' },
  { label: 'Civil Engineering', value: 'civil-engineering' },
  { label: 'Commercial Real Estate', value: 'commercial-real-estate' },
  { label: 'Computer & Network Security', value: 'computer-network-security' },
  { label: 'Computer Games', value: 'computer-games' },
  { label: 'Computer Hardware', value: 'computer-hardware' },
  { label: 'Computer Networking', value: 'computer-networking' },
  { label: 'Computer Software', value: 'computer-software' },
  { label: 'Construction', value: 'construction' },
  { label: 'Consumer Electronics', value: 'consumer-electronics' },
  { label: 'Consumer Goods', value: 'consumer-goods' },
  { label: 'Consumer Services', value: 'consumer-services' },
  { label: 'Cosmetics', value: 'cosmetics' },
  { label: 'Credit Union', value: 'credit-union' },
  { label: 'Dairy', value: 'dairy' },
  { label: 'Defense & Space', value: 'defense-space' },
  { label: 'Design', value: 'design' },
  { label: 'E-Learning', value: 'e-learning' },
  { label: 'Education', value: 'education' },
  { label: 'Education Management', value: 'education-management' },
  { label: 'Electrical/Electronic Manufacturing', value: 'electrical-electronic-manufacturing' },
  { label: 'Energy/Resources', value: 'energy-resources' },
  { label: 'Engineering', value: 'engineering' },
  { label: 'Entertainment', value: 'entertainment' },
  { label: 'Environmental Services', value: 'environmental-services' },
  { label: 'Events Services', value: 'events-services' },
  { label: 'Executive Office', value: 'executive-office' },
  { label: 'Facilities Services', value: 'facilities-services' },
  { label: 'Farming', value: 'farming' },
  { label: 'Finance', value: 'finance' },
  { label: 'Financial Services', value: 'financial-services' },
  { label: 'Fine Art', value: 'fine-art' },
  { label: 'Fishery', value: 'fishery' },
  { label: 'Food & Beverages', value: 'food-beverages' },
  { label: 'Food Production', value: 'food-production' },
  { label: 'Fund-Raising', value: 'fund-raising' },
  { label: 'Furniture', value: 'furniture' },
  { label: 'Gambling & Casinos', value: 'gambling-casinos' },
  { label: 'Glass, Ceramics & Concrete', value: 'glass-ceramics-concrete' },
  { label: 'Government Administration', value: 'government-administration' },
  { label: 'Government Relations', value: 'government-relations' },
  { label: 'Government/Politics', value: 'government-politics' },
  { label: 'Graphic Design', value: 'graphic-design' },
  { label: 'Health, Wellness and Fitness', value: 'health-wellness-fitness' },
  { label: 'Healthcare/Wellness', value: 'healthcare-wellness' },
  { label: 'Higher Education', value: 'higher-education' },
  { label: 'Hospital & Health Care', value: 'hospital-health-care' },
  { label: 'Hospitality', value: 'hospitality' },
  { label: 'Human Resources', value: 'human-resources' },
  { label: 'Import and Export', value: 'import-export' },
  { label: 'Individual & Family Services', value: 'individual-family-services' },
  { label: 'Industrial Automation', value: 'industrial-automation' },
  { label: 'Information Services', value: 'information-services' },
  { label: 'Information Technology and Services', value: 'information-technology-services' },
  { label: 'Insurance', value: 'insurance' },
  { label: 'International Affairs', value: 'international-affairs' },
  { label: 'International Trade and Development', value: 'international-trade-development' },
  { label: 'Internet', value: 'internet' },
  { label: 'Investment Banking', value: 'investment-banking' },
  { label: 'Investment Management', value: 'investment-management' },
  { label: 'Judiciary', value: 'judiciary' },
  { label: 'Law Enforcement', value: 'law-enforcement' },
  { label: 'Law Practice', value: 'law-practice' },
  { label: 'Legal', value: 'legal' },
  { label: 'Legal Services', value: 'legal-services' },
  { label: 'Legislative Office', value: 'legislative-office' },
  { label: 'Leisure, Travel & Tourism', value: 'leisure-travel-tourism' },
  { label: 'Libraries', value: 'libraries' },
  { label: 'Logistics and Supply Chain', value: 'logistics-supply-chain' },
  { label: 'Luxury Goods & Jewelry', value: 'luxury-goods-jewelry' },
  { label: 'Machinery', value: 'machinery' },
  { label: 'Management Consulting', value: 'management-consulting' },
  { label: 'Manufacturing', value: 'manufacturing' },
  { label: 'Maritime', value: 'maritime' },
  { label: 'Market Research', value: 'market-research' },
  { label: 'Marketing and Advertising', value: 'marketing-advertising' },
  { label: 'Mechanical or Industrial Engineering', value: 'mechanical-industrial-engineering' },
  { label: 'Media Production', value: 'media-production' },
  { label: 'Media/Entertainment', value: 'media-entertainment' },
  { label: 'Medical Devices', value: 'medical-devices' },
  { label: 'Medical Practice', value: 'medical-practice' },
  { label: 'Mental Health Care', value: 'mental-health-care' },
  { label: 'Military', value: 'military' },
  { label: 'Mining & Metals', value: 'mining-metals' },
  { label: 'Motion Pictures and Film', value: 'motion-pictures-film' },
  { label: 'Museums and Institutions', value: 'museums-institutions' },
  { label: 'Music', value: 'music' },
  { label: 'Nanotechnology', value: 'nanotechnology' },
  { label: 'Newspapers', value: 'newspapers' },
  { label: 'Non-Profit Organization Management', value: 'non-profit-organization-management' },
  { label: 'Nonprofit/NGO', value: 'nonprofit-ngo' },
  { label: 'Oil & Energy', value: 'oil-energy' },
  { label: 'Online Media', value: 'online-media' },
  { label: 'Outsourcing/Offshoring', value: 'outsourcing-offshoring' },
  { label: 'Package/Freight Delivery', value: 'package-freight-delivery' },
  { label: 'Packaging and Containers', value: 'packaging-containers' },
  { label: 'Paper & Forest Products', value: 'paper-forest-products' },
  { label: 'Performing Arts', value: 'performing-arts' },
  { label: 'Pharmaceuticals', value: 'pharmaceuticals' },
  { label: 'Philanthropy', value: 'philanthropy' },
  { label: 'Photography', value: 'photography' },
  { label: 'Plastics', value: 'Plastics' },
  { label: 'Political Organization', value: 'Political Organization' },
  { label: 'Primary/Secondary Education', value: 'Primary/Secondary Education' },
  { label: 'Printing', value: 'Printing' },
  { label: 'Professional Training & Coaching', value: 'Professional Training & Coaching' },
  { label: 'Program Development', value: 'Program Development' },
  { label: 'Public Policy', value: 'Public Policy' },
  { label: 'Public Relations and Communications', value: 'Public Relations and Communications' },
  { label: 'Public Safety', value: 'Public Safety' },
  { label: 'Publishing', value: 'Publishing' },
  { label: 'Railroad Manufacture', value: 'Railroad Manufacture' },
  { label: 'Ranching', value: 'Ranching' },
  { label: 'Real Estate', value: 'Real Estate' },
  { label: 'Recreational Facilities and Services', value: 'Recreational Facilities and Services' },
  { label: 'Religious Institutions', value: 'Religious Institutions' },
  { label: 'Renewables & Environment', value: 'Renewables & Environment' },
  { label: 'Research', value: 'Research' },
  { label: 'Restaurants', value: 'Restaurants' },
  { label: 'Retail', value: 'Retail' },
  { label: 'Security and Investigations', value: 'Security and Investigations' },
  { label: 'Semiconductors', value: 'Semiconductors' },
  { label: 'Shipbuilding', value: 'Shipbuilding' },
  { label: 'Sporting Goods', value: 'Sporting Goods' },
  { label: 'Sports', value: 'Sports' },
  { label: 'Staffing and Recruiting', value: 'Staffing and Recruiting' },
  { label: 'Supermarkets', value: 'Supermarkets' },
  { label: 'Technology', value: 'Technology' },
  { label: 'Telecommunications', value: 'Telecommunications' },
  { label: 'Textiles', value: 'Textiles' },
  { label: 'Think Tanks', value: 'Think Tanks' },
  { label: 'Tobacco', value: 'Tobacco' },
  { label: 'Tourism/Hospitality', value: 'Tourism/Hospitality' },
  { label: 'Translation and Localization', value: 'Translation and Localization' },
  { label: 'Transportation', value: 'Transportation' },
  { label: 'Utilities', value: 'Utilities' },
  { label: 'Venture Capital & Private Equity', value: 'Venture Capital & Private Equity' },
  { label: 'Veterinary', value: 'Veterinary' },
  { label: 'Warehousing', value: 'Warehousing' },
  { label: 'Wholesale', value: 'Wholesale' },
  { label: 'Wine and Spirits', value: 'Wine and Spirits' },
  { label: 'Wireless', value: 'Wireless' },
  { label: 'Writing and Editing', value: 'Writing and Editing' },
]
